export enum GymMembershipClientStatus {
  All = 0,
  Active = 1,
  NotActive = 2
}
